const langs = ["en", "es", "pt"];
const files = [
  "chat",
  "base",
  "bookmarks",
  "grid",
  "video_watermarks",
  "layout_builder",
  "alarm_views",
  "recording_request",
  "actions",
  "messages",
  "alarm_level",
  "buttons",
  "alarm",
  "seproban",
  "commands",
  "router",
  "bridge",
  "camera",
  "log_incident",
  "presets",
  "traffic",
  "access_devices",
  "token",
  "action_plan",
  "sip",
  "notifications",
  "logs",
  "profiles",
  "swift_collector",
  "swift_sensor",
  "swift_account",
  "pages",
  "external_token",
  "external_user",
  "intelexvision",
  "alarm_comment",
  "pagination",
  "unit_groups",
  "tenants",
  "master_tenants",
  "video_wall",
  "intelexvision_alarm_type",
  "vxg_camera",
  "person_list",
  "reseller",
  "intelexvision_event",
  "vxg_master_account",
  "region",
  "auth_two_factor",
  "country",
  "safr",
  "login",
  "camera_proxy",
  "luna",
  "purge_alarm",
  "dahua_dvr",
  "dahua_camera",
  "cm_master_account",
  "schedule_alarm",
  "luxriot",
  "density_device",
  "detection_event",
  "unit",
  "omniview_reseller",
  "plane",
  "municipality",
  "users",
  "generic_devices",
  "account_settings",
  "plate",
  "breadcrumbs",
  "log_microservice",
  "tags",
  "share_video_link",
  "installation_components",
  "digital_signature",
  "pacom",
  "intelbras",
  "scripts",
  "alarms_commands",
  "chatbot_fake",
  "helpdesk",
  "proxy_rtsp_server",
  "pbx_master_account",
  "pbx_device",
  "pbx_ip_block",
  "hanwha_dvr",
  "hanwha_camera",
  "hanwha_alarm_config",
  "hanwha_log",
  "app_modules",
  "pbx_call",
  "risk",
  "bau_complement",
  "simulacrum",
  "procedure_states",
  "security_self_audit",
  "custom_forms",
  "dmp",
  "hikvision_dvr",
  "hikvision_master_accounts",
  "hikvision_camera",
  "chatbot",
  "icons_info",
  "alarm_rules",
  "facility_category",
  "unit_deactivation_catalog",
  "ntechlab",
  "alarm_rules",
  "institutions",
  "companies",
  "employees",
  "employees_units",
  "institutions",
  "alarm_groups",
  "providers",
  "bosch",
  "video_tour",
  "operational_security",
  "operational_procedure",
  "omnicloud_fr",
  "maintenance",
  "service_orders",
  "ai_analytics_servers",
  "distribution_list",
  "testing",
  "custom_timezones",
  "teams",
  "directory",
  "planning",
  "policy_exception",
  "pisos",
  "brigades",
  "training",
  "patrol_logs",
  "charts_embedder",
  "holliday",
  "inventory",
  "inventory_brand_catalog",
  "inventory_project_catalog",
  "inventory_equipment_type_catalog",
  "billing",
  "billing_holiday",
  "billing_price",
  "billing_finance",
  "assigned_regions",
  "bookmarkCategory",
  "assigned_video_tours",
  "users_rh",
  "totem_logs",
  "assigned_video_tours",
  "user_group_selection_option",
  "storage_provider",
  "bulk_edit",
  "victronenergy",
  "stream_type",
];

const messages = {};

for (const lang of langs) {
  for (const fileName of files) {
    const {default: file} = require(`./${lang}/${fileName}`);
    const fileContent = file.namespaced ? file : file[fileName];
    if (messages[lang]) {
      messages[lang] = Object.assign(messages[lang], {...fileContent});
    } else {
      messages[lang] = {};
      messages[lang] = Object.assign(messages[lang], {...fileContent});
    }
  }
}

export default messages;
